// Real photos of our cinnamon, generated from resources/ by scripts/optimize-images.sh.
// Each photo has a 640px-wide and a full-size WebP; `width`/`height` are the full-size
// dimensions and are used to reserve space before the image loads.
import bundleEndsGroup640 from './bundle-ends-group-640.webp';
import bundleEndsGroup from './bundle-ends-group-1280.webp';
import estateTree640 from './estate-cinnamon-tree-640.webp';
import estateTree from './estate-cinnamon-tree-1280.webp';
import fineQuills640 from './fine-quills-bundle-640.webp';
import fineQuills from './fine-quills-bundle-1280.webp';
import gardenBundles640 from './garden-bundles-640.webp';
import gardenBundles from './garden-bundles-1280.webp';
import gardenMixed640 from './garden-mixed-quills-640.webp';
import gardenMixed from './garden-mixed-quills-1280.webp';
import gardenCloseup640 from './garden-quills-closeup-640.webp';
import gardenCloseup from './garden-quills-closeup-1280.webp';
import goldenHour640 from './golden-hour-bundles-640.webp';
import goldenHour from './golden-hour-bundles-1280.webp';
import lawnBundles640 from './lawn-four-bundles-640.webp';
import lawnBundles from './lawn-four-bundles-1280.webp';
import nurseryPath640 from './nursery-path-640.webp';
import nurseryPath from './nursery-path-1280.webp';
import nurserySeedlings640 from './nursery-seedlings-640.webp';
import nurserySeedlings from './nursery-seedlings-1280.webp';
import crossSection640 from './quill-cross-section-640.webp';
import crossSection from './quill-cross-section-1280.webp';
import quillEndsTop640 from './quill-ends-top-640.webp';
import quillEndsTop from './quill-ends-top-1280.webp';
import withLeaves640 from './quills-with-leaves-640.webp';
import withLeaves from './quills-with-leaves-1280.webp';
import withLeavesSide640 from './quills-with-leaves-side-640.webp';
import withLeavesSide from './quills-with-leaves-side-1280.webp';
import thickQuills640 from './thick-quills-bundle-640.webp';
import thickQuills from './thick-quills-bundle-1280.webp';
import threeBundles640 from './three-bundles-640.webp';
import threeBundles from './three-bundles-1280.webp';
// Older photos of the estate and workshop (640px versions made with cwebp -q 80 -resize 640 0)
import estateTrees640 from '../harvesting-640.webp';
import estateTrees from '../harvesting.webp';
import peeling640 from '../peeling-640.webp';
import peeling from '../peeling.webp';
import grading640 from '../grading-640.webp';
import grading from '../grading.webp';

const photo = (small, large, width, height, alt) => ({
  src: large,
  srcSet: `${small} 640w, ${large} ${width}w`,
  width,
  height,
  alt,
});

const photos = {
  goldenHour: photo(goldenHour640, goldenHour, 1280, 960,
    'Bundles of Ceylon cinnamon quills on a cloth outdoors at sunset'),
  gardenBundles: photo(gardenBundles640, gardenBundles, 1280, 960,
    'Tied bundles of cinnamon quills of different thicknesses, laid out in a garden'),
  lawnBundles: photo(lawnBundles640, lawnBundles, 1280, 906,
    'Four bundles of fine cinnamon quills standing on a lawn'),
  gardenMixed: photo(gardenMixed640, gardenMixed, 1280, 1010,
    'Cinnamon quill bundles of several grades on a table outside'),
  gardenCloseup: photo(gardenCloseup640, gardenCloseup, 1280, 1097,
    'Close view of tied cinnamon quill bundles with grass behind'),
  estateTree: photo(estateTree640, estateTree, 1010, 1280,
    'A young cinnamon tree with fresh red-tinged leaves growing on the estate'),
  nurserySeedlings: photo(nurserySeedlings640, nurserySeedlings, 1280, 1267,
    'Rows of cinnamon seedlings in the nursery'),
  nurseryPath: photo(nurseryPath640, nurseryPath, 960, 1280,
    'Potted cinnamon seedlings lining a path in the nursery'),
  withLeaves: photo(withLeaves640, withLeaves, 1280, 1141,
    'Cinnamon quill bundles arranged with fresh cinnamon leaves'),
  withLeavesSide: photo(withLeavesSide640, withLeavesSide, 1280, 1077,
    'Four bundles of cinnamon quills with a sprig of cinnamon leaves'),
  fineQuills: photo(fineQuills640, fineQuills, 960, 1280,
    'A tight bundle of thin, pale cinnamon quills'),
  crossSection: photo(crossSection640, crossSection, 1050, 1280,
    'End view of cinnamon quills showing many thin rolled layers of bark'),
  quillEndsTop: photo(quillEndsTop640, quillEndsTop, 960, 1280,
    'Top view of a bundle of cinnamon quills showing the rolled ends'),
  thickQuills: photo(thickQuills640, thickQuills, 1269, 1280,
    'A bundle of wider cinnamon quills tied with string'),
  threeBundles: photo(threeBundles640, threeBundles, 1280, 895,
    'Three bundles of cinnamon quills of different lengths and thicknesses'),
  bundleEndsGroup: photo(bundleEndsGroup640, bundleEndsGroup, 1280, 1052,
    'Four cinnamon bundles seen end-on, showing the curled layers'),
  estateTrees: photo(estateTrees640, estateTrees, 1200, 649,
    'Mature cinnamon trees growing on the estate'),
  peeling: photo(peeling640, peeling, 885, 540,
    'A peeler stripping bark from a cinnamon branch'),
  grading: photo(grading640, grading, 1024, 1024,
    'Workers sorting and grading cinnamon quills at long tables'),
};

// The key doubles as an id, used to look up translated alt text
Object.keys(photos).forEach((id) => { photos[id].id = id; });

export default photos;
